import script from "./FloorPlan2D.vue?vue&type=script&setup=true&lang=js"
export * from "./FloorPlan2D.vue?vue&type=script&setup=true&lang=js"

import "./FloorPlan2D.vue?vue&type=style&index=0&id=818bc24e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-818bc24e"]])

export default __exports__